import React from 'react';
import PageLayout from '../components/PageLayout';

const AboutUs = () => (
  <PageLayout title="About Us">
    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 0, marginBottom: 8, color: '#2D1A00' }}>Our Story</h2>
    <p>Chakna Point was born from a simple idea — making it easy to get the perfect snacks for your drinks. Whether you're hosting a party, having a chill evening with friends, or just craving some masala peanuts with your beer, we've got you covered.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>What We Do</h2>
    <p>We curate and deliver premium chakna, namkeen, and party snacks through convenient pickup points near you. No more last-minute runs to the store — just order on the app and pick up in 10 minutes.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>Our Mission</h2>
    <p>To become India's go-to platform for party snacks and chakna, making every gathering more enjoyable with the perfect food pairings.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>What Makes Us Different</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li><strong>Curated Selection:</strong> Only the best quality chakna and snacks make it to our platform.</li>
      <li><strong>Quick Pickup:</strong> Ready in 10 minutes at your nearest pickup point.</li>
      <li><strong>Drink Pairings:</strong> We suggest the perfect snack for every drink.</li>
      <li><strong>Combo Deals:</strong> Save more with our specially curated party packs.</li>
      <li><strong>Community:</strong> Join thousands of snack lovers who trust Chakna Point.</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>Our Values</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li><strong>Quality First:</strong> We never compromise on the quality of our products.</li>
      <li><strong>Customer Happiness:</strong> Your satisfaction is our top priority.</li>
      <li><strong>Innovation:</strong> We constantly improve our app and services.</li>
      <li><strong>Community:</strong> We support local vendors and businesses.</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>Contact</h2>
    <p><strong>Email:</strong> support@chaknapoint.com<br /><strong>Phone:</strong> +91 98765 43210</p>
  </PageLayout>
);

export default AboutUs;
